import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import Swal from 'sweetalert2';

@Injectable()
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ConfirmDialogComponent>;


  showError(message:any){
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
    })
  }

  showSuccess(message:any){
    Swal.fire({
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1000
    })
  }

  fundShowSuccess(message:any){
    Swal.fire({
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 2500
    })
  }

  showFixedSuccess(message:any){
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: message,
    })
  }

  showConfirmMessage(
    dialogBoxTitle: string,
    message: string,
    onSubmit: () => void
  ) {
    Swal.fire({
      title: `<div style="text-align: left; font-size: 1rem; font-weight: ; color: #008080;">${dialogBoxTitle}</div>`,
      html: `
        <div
          style="
            font-size: 1.15rem;
            font-weight: 700;
            color: #000000;
            text-align: left;
            max-height: 30vh;
            overflow-y: auto;
          ">
          ${message}
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: true,
      width: '25vw',            
      customClass: {
        popup: 'responsive-swal'
      },
      confirmButtonText: 'Submit',
      focusConfirm: true,
      confirmButtonColor: '#008080',
    }).then((result) => {
      if (result.isConfirmed) {
        onSubmit();
      }
    });
  }

}
